jQuery(document).ready(function ($) {
  var cidadesPlanos = ['blumenau', 'pomerode', 'indaial', 'ilhota', 'gaspar', 'timbo']

  var cidadesPlanosProprietario = ['blumenau']

  $('.select-plano-cidade').change(function (event) {
    if (cidadesPlanos.indexOf(this.value) >= 0) {
      $('.planos-blumenau-regiao').slideDown()
      $('.planos-demais-cidades').slideUp()
    } else {
      $('.planos-blumenau-regiao').slideUp()
      $('.planos-demais-cidades').slideDown()
    }
  })

  $(document).on('click', '.btn-anunciar', function (event) {
    event.preventDefault()

    var data = {}
    if (this.getAttribute('data-plano') != '' && this.getAttribute('data-plano') != null) data.plano = this.getAttribute('data-plano')

    if ($('.select-plano-cidade')[0]) data.cidade = $('.select-plano-cidade').val()

    var html = $(this).html()

    $(this).html('<i class="fa fa-spin fa-spinner"></i> Aguarde...')

    $.ajax({
      url: '/anuncie',
      type: 'POST',
      data: data
    }).done(function (data) {
      if (data == null || data == '') {
      } else {
        $('#modal .modal-data').html(data)
        $('#modal').show()

        setTimeout(function () {
          createSelect2Load($('#modal .modal-data .select2-load')[0])
          $('#modal .modal-data input').trigger('click')

          $('#modal .modal-data input[data-mask]').each(function (index, el) {
            $(el).mask(el.getAttribute('data-mask'), { reverse: el.getAttribute('data-reverse') == '1' })
          })
        }, 100)
      }

      $(event.currentTarget).html(html)
    })

    return false
  })

  var preRegistroFormValid = 0
  $(document).on('submit', '.preregistro-anunciante-form', function (event) {
    var btn = $(this).find('.contato-submit-wrapper .btn[type=submit]')
    var btnHtml = btn.html()

    var hasError = 0
    $(this)
      .find('.campo-validacao-obrigatorio')
      .each(function (index, el) {
        if ($(el).val() == '') {
          $(el).closest('.campo-default').find('.campo-alerta').fadeIn(300)
          hasError = 1
        }
      })

    if (hasError) {
      event.preventDefault()

      preRegistroFormValid = 0

      $(this).find('.contato-form-wrapper').stop().shake()

      return false
    }

    //
    btn.html('<i class="fa fa-spin fa-spinner"></i> Aguarde...')

    if (!preRegistroFormValid) {
      event.preventDefault()

      $.ajax({
        url: '/api/anunciantes/verifica-novo-cadastro',
        type: 'GET',
        data: {
          email: $(this).find('input[name=email]').val()
        }
      })
        .done(data => {
          if (data.status == 'success') {
            preRegistroFormValid = true
            $(this).trigger('submit')
          } else {
            btn.html(btnHtml)

            swal(
              {
                title: 'Atenção!',
                text: 'Seu e-mail já está cadastrado como anunciante. Caso não lembre da sua senha, utilize a opção Esqueci minha senha.',
                type: 'warning'
              },
              function () {
                window.location.href = '/login'
                $('#modal .modal-fechar').trigger('click')
              }
            )
          }
        })
        .fail(() => {
          swal({
            title: 'Oops!',
            text: 'Ocorreu um erro ao validar seu cadastro. Tente novamente.',
            type: 'error'
          })
          btn.html(btnHtml)
        })
    } else {
      localStorage.setItem('registro.etapa', 1)
      localStorage.setItem('registro.perfil', null)
      localStorage.setItem('registro.nome', $(this).find('input[name=nome]').val())
      localStorage.setItem('registro.razao_social', $(this).find('input[name=nome]').val())
      localStorage.setItem('registro.nome_responsavel', $(this).find('input[name=nome]').val())
      localStorage.setItem('registro.telefone', $(this).find('input[name=telefone]').val())
      localStorage.setItem('registro.telefone_responsavel', $(this).find('input[name=telefone]').val())
    }
  })

  if ($('#main-anuncie')[0]) {
    const registro = new Vue({
      el: '#main-anuncie',
      data: function () {
        this.selecionaEtapa(localStorage.getItem('registro.etapa') || '1', 0)

        var that = this

        $(document).on('change', '#main-anuncie select', function (event) {
          that[event.currentTarget.name] = event.currentTarget.value
        })

        $(document).on('keyup', '#main-anuncie input[name=cartao_numero]', function (e) {
          that.cartao_bandeira = $.payment.cardType($(e.currentTarget).val())
          $('input[name=cartao_numero]').mask('99999999999999999999')
          $('input[name=cartao_cvv]').mask('99999')

          if (that.cartao_bandeira == null) return

          $('.lista-cartoes img').addClass('off')
          $('.lista-cartoes img.cartao-' + that.cartao_bandeira).removeClass('off')

          if (that.cartao_bandeira == 'visa') $('input[name=cartao_numero]').mask('9999999999999999')
          else if (that.cartao_bandeira == 'mastercard') $('input[name=cartao_numero]').mask('9999999999999999')
          else if (that.cartao_bandeira == 'elo') $('input[name=cartao_numero]').mask('9999999999999999')
          else if (that.cartao_bandeira == 'dinersclub') $('input[name=cartao_numero]').mask('99999999999999')
          else $('input[name=cartao_numero]').mask('99999999999999999999')
        })

        setTimeout(function () {
          that.selecionaPagamento()
        }, 200)

        return {
          etapa: localStorage.getItem('registro.etapa') || 1,
          perfil: localStorage.getItem('registro.perfil') || '',
          razao_social: localStorage.getItem('registro.razao_social'),
          cnpj: localStorage.getItem('registro.cnpj') || '',
          cpf: localStorage.getItem('registro.cpf') || '',
          telefone: localStorage.getItem('registro.telefone') || '',
          creci: localStorage.getItem('registro.creci') || '',
          nome_exibicao: localStorage.getItem('registro.nome_exibicao') || '',
          website: localStorage.getItem('registro.website') || '',
          desenvolvedor: localStorage.getItem('registro.desenvolvedor') || '',
          cidade: localStorage.getItem('registro.cidade') || '',
          nome_responsavel: localStorage.getItem('registro.nome_responsavel') || '',
          cpf_responsavel: localStorage.getItem('registro.cpf_responsavel') || '',
          email_responsavel: localStorage.getItem('registro.email_responsavel') || '',
          telefone_responsavel: localStorage.getItem('registro.telefone_responsavel') || '',
          nome: localStorage.getItem('registro.nome') || '',
          email: localStorage.getItem('registro.email') || $('input[name=email]').val(),
          senha: localStorage.getItem('registro.senha') || '',
          plano: localStorage.getItem('registro.plano') || '',

          cartao_numero: '',
          cartao_cvv: '',
          cartao_validade: '',
          cartao_titular: '',
          cartao_bandeira: '',

          plano_valor: localStorage.getItem('registro.plano_valor') || 0,
          plano_nome: localStorage.getItem('registro.plano_nome') || 0,
          plano_info: localStorage.getItem('registro.plano_info') || 0,

          pagamento: localStorage.getItem('registro.pagamento') || 'cartao',
          showPagos: true,
          showFree: false,
          proprietario_plano: cidadesPlanosProprietario.indexOf(localStorage.getItem('registro.cidade')) <= -1 ? 2 : 1,
          ignorePerfil: 0,
          classRequiredCorretor: localStorage.getItem('registro.perfil') == 'corretor' ? 'campo-validacao-obrigatorio' : '',
          classRequiredOutros: localStorage.getItem('registro.perfil') != 'corretor' ? 'campo-validacao-obrigatorio' : '',

          select2Loaded: false
        }
      },

      watch: {
        etapa: function (val, oldVal) {
          localStorage.setItem('registro.etapa', val)
        },
        perfil: function (val, oldVal) {
          localStorage.setItem('registro.perfil', val)

          if (!this.ignorePerfil) this.selecionaPerfil()
        },
        razao_social: function (val, oldVal) {
          localStorage.setItem('registro.razao_social', val)
        },
        cnpj: function (val, oldVal) {
          localStorage.setItem('registro.cnpj', val)
        },
        cpf: function (val, oldVal) {
          localStorage.setItem('registro.cpf', val)
        },
        telefone: function (val, oldVal) {
          localStorage.setItem('registro.telefone', val)
        },
        creci: function (val, oldVal) {
          localStorage.setItem('registro.creci', val)
        },
        nome_exibicao: function (val, oldVal) {
          localStorage.setItem('registro.nome_exibicao', val)
        },
        website: function (val, oldVal) {
          localStorage.setItem('registro.website', val)
        },
        desenvolvedor: function (val, oldVal) {
          localStorage.setItem('registro.desenvolvedor', val)
        },
        cidade: function (val, oldVal) {
          localStorage.setItem('registro.cidade', val)
          this.showPagos = cidadesPlanos.indexOf(this.cidade) >= 0
          this.showFree = false
          this.proprietario_plano = cidadesPlanosProprietario.indexOf(this.cidade) <= -1 ? 2 : 1
        },
        nome_responsavel: function (val, oldVal) {
          localStorage.setItem('registro.nome_responsavel', val)
        },
        cpf_responsavel: function (val, oldVal) {
          localStorage.setItem('registro.cpf_responsavel', val)
        },
        email_responsavel: function (val, oldVal) {
          localStorage.setItem('registro.email_responsavel', val)
        },
        telefone_responsavel: function (val, oldVal) {
          localStorage.setItem('registro.telefone_responsavel', val)
        },
        nome: function (val, oldVal) {
          localStorage.setItem('registro.nome', val)
        },
        email: function (val, oldVal) {
          localStorage.setItem('registro.email', val)
        },
        senha: function (val, oldVal) {
          localStorage.setItem('registro.senha', val)
        },
        pagamento: function (val, oldVal) {
          localStorage.setItem('registro.pagamento', val)
          this.selecionaPagamento()
        },
        plano: function (val, oldVal) {
          localStorage.setItem('registro.plano', val)
          // this.selecionaEtapa(5);
        },
        plano_valor: function (val, oldVal) {
          localStorage.setItem('registro.plano_valor', val)
        },
        plano_nome: function (val, oldVal) {
          localStorage.setItem('registro.plano_nome', val)
        },
        plano_info: function (val, oldVal) {
          localStorage.setItem('registro.plano_info', val)
        }
      },
      methods: {
        validateFields: function () {
          var hasError = 0
          $('#main-anuncie .etapa' + this.etapa + ' .campo-validacao-obrigatorio').each(function (index, el) {
            if ($(el).attr('type') == 'checkbox' && !$(el).is(':checked')) {
              $(el).closest('.campo-default').find('.campo-alerta').fadeIn(300)
              hasError = 1
            } else if ($(el).val() == '') {
              $(el).closest('.campo-default').find('.campo-alerta').fadeIn(300)
              hasError = 1
            }
          })

          if (hasError) {
            event.preventDefault()

            $('#main-anuncie .etapa' + this.etapa + ' .form-clear ').shake()

            return false
          }

          return true
        },

        validaEtapa2: function () {
          var btn = $(this)

          if (!this.validateFields()) return false

          if (this.perfil == 'corretor' || this.perfil == 'proprietario') {
            if (!validateCPF(this.cpf)) {
              swal({
                title: 'CPF informado é inválido!',
                text: 'Confira se você digitou corretamente e tente novamente.',
                type: 'error'
              })
              return false
            }
          } else {
            if (!validateCNPJ(this.cnpj)) {
              swal({
                title: 'CNPJ informado é inválido!',
                text: 'Confira se você digitou corretamente e tente novamente.',
                type: 'error'
              })
              return false
            }
          }

          this.selecionaEtapa(3)
          // var btn = $('#main-anuncie .etapa'+this.etapa+' .btn-avancar');
          // var btnHtml = btn.html();
          // btn.html('<i class="fa fa-spin fa-spinner"></i> Validando...');

          // $.ajax({
          // 	url: btn.attr('data-href'),
          // 	type: 'POST',
          // 	data: {
          // 		creci: this.creci
          // 	}
          // })
          // .done(function(data) {

          // 	if (data.status == 'success') {
          //        	btn.html(btnHtml);
          //  				this.selecionaEtapa(3);
          // 	}
          //        else {
          //            swal({
          //                title: "Algo deu errado!",
          //                text:  data.message,
          //                type: "error",
          //            });
          //        	btn.html(btnHtml);
          //        }

          // }).fail(function() {
          //           swal({
          //               title: "Algo deu errado!",
          //               text: 'Verifique se você preencheu os campos corretamente.',
          //               type: "error",
          //           });
          //       	btn.html(btnHtml);
          // });
        },
        validaEtapa3: function () {
          if (!this.validateFields()) return false

          this.selecionaEtapa(4)
        },
        validaEtapa4: function (plano, valor, nome, info) {
          this.plano = plano
          this.plano_valor = valor
          this.plano_nome = nome
          this.plano_info = info
          this.pagamento = valor == 0 ? 'boleto' : 'cartao'
          this.selecionaEtapa(5)
        },

        finalizarRegistro: function () {
          if (this.pagamento == 'cartao') {
            if (!this.validateFields()) return false

            if (!$.payment.validateCardNumber($('input[name=cartao_numero]').val())) {
              swal({
                title: 'Algo deu errado!',
                html: 'O número do cartão de crédito é inválido. <br /> <br /> Verifique os dados preenchidos e tente novamente.',
                type: 'error'
              })
              return false
            }

            var exp = $('input[name=cartao_validade]').val().split('/')

            if (exp[1].length != 4) {
              swal({
                title: 'Algo deu errado!',
                html:
                  'A data de validade deve estar no <br />formato mm/aaaa (ex: 11/2020). <br /> <br /> Verifique os dados preenchidos e tente novamente.',
                type: 'error'
              })
              return false
            }

            if (!$.payment.validateCardExpiry(exp[0], exp[1])) {
              swal({
                title: 'Algo deu errado!',
                html: 'A data de validade informada é inválida. <br /> <br /> Verifique os dados preenchidos e tente novamente.',
                type: 'error'
              })
              return false
            }

            if (!$.payment.validateCardCVC($('input[name=cartao_cvv]').val(), $.payment.cardType($('input[name=cartao_numero]').val()))) {
              swal({
                title: 'Algo deu errado!',
                html:
                  'O código de segurança do seu cartão de crédito informado é inválido. <br /> <br /> Verifique os dados preenchidos e tente novamente.',
                type: 'error'
              })
              return false
            }
          } else {
            if (!$('input[name=aceito_contrato]').is(':checked')) {
              $('input[name=aceito_contrato]').closest('.campo-default').find('.campo-alerta').fadeIn(300)
              $('#main-anuncie .etapa' + this.etapa + ' .form-clear ').shake()
              return false
            }
          }

          var modalTexto =
            '<div class="modal-form-anunciar"><div class="modal-form-anunciar-titulo">Seu cadastro:</div><p class="modal-form-texto-info"></p></div>'
          var execucaoMessage = [
            'Criando sua conta...',
            'Criando seu usuário de acesso...',
            'Adicionando suas permissões...',
            'Finalizando...'
          ]

          var execucao = 0

          $('#modal .modal-data').html(modalTexto)
          $('#modal .modal-data .modal-form-texto-info').html(execucaoMessage[execucao])
          $('#modal').show()
          $('#modal .modal-fechar').hide()

          var atualizaMensagens = setInterval(function () {
            if (execucao >= 0 && execucao <= 3) {
              execucao++

              $('#modal .modal-data .modal-form-texto-info').html(execucaoMessage[execucao])
            }
          }, 800)

          $.ajax({
            url: $('#form-anunciar-registro').attr('action'),
            type: 'POST',
            data: {
              perfil: this.perfil,
              razao_social: this.razao_social,
              cnpj: this.cnpj,
              cpf: this.cpf,
              creci: this.creci,
              nome_exibicao: this.nome_exibicao,
              website: this.website,
              desenvolvedor: this.desenvolvedor,
              cidade: this.cidade,
              nome_responsavel: this.nome_responsavel,
              cpf_responsavel: this.cpf_responsavel,
              email_responsavel: this.email_responsavel,
              telefone_responsavel: this.telefone_responsavel,
              nome: this.nome,
              telefone: this.telefone,
              email: this.email,
              senha: this.senha,
              plano: this.plano,
              cartao_numero: this.cartao_numero,
              cartao_cvv: this.cartao_cvv,
              cartao_validade: this.cartao_validade,
              cartao_titular: this.cartao_titular,
              cartao_bandeira: this.cartao_bandeira,
              pagamento: this.pagamento
            }
          })
            .done(function (data) {
              // $('#modal .modal-fechar').show();
              clearTimeout(atualizaMensagens)
              if (data.status == 'success') {
                // if (ga) ga('send', 'pageview', '/anuncie/novo-cadastro/concluido')

                $('#modal .modal-data .modal-form-texto-info').html(data.message)
                $('#modal .modal-data .modal-form-anunciar-titulo').html('Sucesso!')
                $('#modal .modal-data .modal-form-anunciar').append(
                  '<br /><p class="more-text center" class="center">Enviamos para seu e-mail os dados de acesso à sua conta. Caso não tenha recebido, você poderá recuperar sua senha acessando a área de <a href="https://admin.imoveis-sc.com.br/anunciantes/index/recovery"  target="_blank">recuperação de senha</a> no login da área de anunciantes.</p>'
                )
                $('#modal .modal-data .modal-form-anunciar').append(
                  '<br /><br /><p class="center"><a class="btn" href="https://www.imoveis-sc.com.br/anunciantes" target="_blank">Área de Anunciantes</a></p>'
                )
                $('#modal .modal-data .modal-form-anunciar').append(
                  '<br /><br /><p class="center more-text" style=""><a href="/">Voltar para o site</a></p>'
                )
                localStorage.setItem('registro.etapa', 1)
                localStorage.setItem('registro.perfil', '')
                localStorage.setItem('registro.razao_social', '')
                localStorage.setItem('registro.cnpj', '')
                localStorage.setItem('registro.cpf', '')
                localStorage.setItem('registro.telefone', '')
                localStorage.setItem('registro.creci', '')
                localStorage.setItem('registro.nome_exibicao', '')
                localStorage.setItem('registro.website', '')
                localStorage.setItem('registro.desenvolvedor', '')
                localStorage.setItem('registro.cidade', '')
                localStorage.setItem('registro.nome_responsavel', '')
                localStorage.setItem('registro.cpf_responsavel', '')
                localStorage.setItem('registro.email_responsavel', '')
                localStorage.setItem('registro.telefone_responsavel', '')
                localStorage.setItem('registro.nome', '')
                localStorage.setItem('registro.telefone', '')
                localStorage.setItem('registro.email', '')
                localStorage.setItem('registro.senha', '')
                localStorage.setItem('registro.plano', '')
                localStorage.setItem('registro.plano_valor', '')
                localStorage.setItem('registro.plano_nome', '')
                localStorage.setItem('registro.plano_info', '')
                localStorage.setItem('registro.pagamento', '')
              } else {
                clearTimeout(atualizaMensagens)
                $('#modal .modal-fechar').show()
                $('#modal .modal-data .modal-form-texto-info').html(data.message)
                $('#modal .modal-data .modal-form-anunciar-titulo').html('Opss!')
              }
            })
            .fail(function () {
              $('#modal .modal-fechar').show()
            })

          return false
        },
        selecionaPerfil: function () {
          if (this.perfil != '') {
            $('.anuncie-perfil li').removeClass('active')

            $('.anuncie-perfil input:checked').closest('li').addClass('active')

            this.selecionaEtapa(2)

            /*
						if (this.perfil != 'proprietario')
							this.selecionaEtapa(2);
						else
							this.selecionaEtapa(6);*/
          }
        },

        selecionaPagamento: function () {
          if (this.pagamento != '') {
            $('.pagamento-selecao li').removeClass('active')

            $('.pagamento-selecao input:checked').closest('li').addClass('active')
          }
        },

        selecionaEtapa: function (etapa = 1, scroll = 1) {
          var that = this
          this.etapa = etapa
          $('#main-anuncie')
            .removeClass()
            .addClass('etapa' + etapa)

          if (this.etapa == 1) {
            // if ($('#main-anuncie .etapa.etapa1 input[type=radio]:checked')[0])
            // $('#main-anuncie .etapa.etapa1 input[type=radio]:checked')[0].checked = 0;
            // this.ignorePerfil = 1;
            $('#goback').trigger('click')
            localStorage.setItem('registro.perfil', '')
            this.perfil = ''

            // this.ignorePerfil = 0;
          } else {
            $('#main-anuncie input[name=cpf]')
              .removeClass('campo-validacao-obrigatorio')
              .addClass(this.perfil == 'corretor' || this.perfil == 'proprietario' ? 'campo-validacao-obrigatorio' : '')
            $('#main-anuncie input[name=cnpj]')
              .removeClass('campo-validacao-obrigatorio')
              .addClass(this.perfil != 'corretor' && this.perfil != 'proprietario' ? 'campo-validacao-obrigatorio' : '')
            // $('#main-anuncie input[name=nome_responsavel]').removeClass('campo-validacao-obrigatorio').addClass(this.perfil != 'corretor' ? 'campo-validacao-obrigatorio' : '');
            // $('#main-anuncie input[name=cpf_responsavel]').removeClass('campo-validacao-obrigatorio').addClass(this.perfil != 'corretor' ? 'campo-validacao-obrigatorio' : '');
            // $('#main-anuncie input[name=email_responsavel]').removeClass('campo-validacao-obrigatorio').addClass(this.perfil != 'corretor' ? 'campo-validacao-obrigatorio' : '');
            // $('#main-anuncie input[name=telefone_responsavel]').removeClass('campo-validacao-obrigatorio').addClass(this.perfil != 'corretor' ? 'campo-validacao-obrigatorio' : '');
            $('#main-anuncie input[name=creci]')
              .removeClass('campo-validacao-obrigatorio')
              .addClass(this.perfil != 'construtora' && this.perfil != 'proprietario' ? 'campo-validacao-obrigatorio' : '')
            $('#main-anuncie input[name=nome]').removeClass('campo-validacao-obrigatorio').addClass('campo-validacao-obrigatorio')
            $('#main-anuncie input[name=telefone]')
              .removeClass('campo-validacao-obrigatorio')
              .addClass(this.perfil != 'corretor' ? 'campo-validacao-obrigatorio' : '')
          }
          // switch (this.etapa) {
          //   case 1:
          //     if (ga) ga('send', 'pageview', '/anuncie/novo-cadastro/selecionar-perfil')
          //     break
          //   case 2:
          //     if (ga && this.perfil == 'corretor') ga('send', 'pageview', '/anuncie/novo-cadastro/corretor')
          //     else if (ga) ga('send', 'pageview', '/anuncie/novo-cadastro/empresa')
          //     break
          //   case 3:
          //     if (ga && this.perfil == 'corretor') ga('send', 'pageview', '/anuncie/novo-cadastro/acessos')
          //     else if (ga) ga('send', 'pageview', '/anuncie/novo-cadastro/responsavel')
          //     break
          //   case 4:
          //     if (ga) ga('send', 'pageview', '/anuncie/novo-cadastro/plano')
          //     break
          //   case 5:
          //     if (ga) ga('send', 'pageview', '/anuncie/novo-cadastro/form-pagamento')
          //     break
          //   default:
          //     break
          // }

          setTimeout(function () {
            $('#main-anuncie .etapa' + etapa + ' select').each(function (index, el) {
              if ($(el).hasClass('vselect2')) {
                $(el).select2()
              } else if ($(el).hasClass('vselect2-load')) {
                if (!that.select2CidadeLoaded || el.getAttribute('name') != 'cidade') {
                  if (that.cidade != '' && that.cidade != null) $(el).attr('data-value', that.cidade)

                  createSelect2Load(el)

                  that.select2CidadeLoaded = true
                }
              }
            })

            $('#div-etapa-2 input[data-mask]').each(function (index, el) {
              $(el).mask(el.getAttribute('data-mask'), { reverse: el.getAttribute('data-reverse') == '1' })
            })

            $('input[name=nome_exibicao]').unmask()
          }, 500)

          if (scroll)
            $('html,body')
              .stop()
              .animate({ scrollTop: $('.guia-etapas').offset().top }, 300)
        }
      }
    })
  }
})

// name="perfil"
// name="razao_social"
// name="cnpj"
// name="telefone"
// name="creci"
// name="nome_exibicao"
// name="website"
// name="desenvolvedor"
// name="cidade"
// name="nome_responsavel"
// name="cpf_responsavel"
// name="email_responsavel"
// name="telefone_responsavel"
// name="nome"
// name="telefone"
// name="email"
// name="senha"
// name="plano"
